import React, { useState } from 'react';
import { Card, Button, Form, Input, message, Table, Select } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { createMatchIncident, deleteIncident } from 'api/events';
import IncidentCard from 'components/Jornadas/IncidentCard';

const RegisterCard = ({ title, children, incidentType = '', data, teamList, reloadStats }) => {
  const { matchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async values => {
    setLoading(true);
    const incident = {
      club_id: Number(values.club_id),
      player_number: Number(values.player_number),
      incident_type: incidentType,
    };

    switch (incidentType) {
      case 'goal':
        incident.amount = Number(values?.goal_amount);
        break;
      case 'card':
        incident.card_color = values?.card_color;
        incident.amount = 1;
        break;
      case 'free_throw':
        incident.amount = Number(values?.free_throw);
        break;
      case 'two_points':
        incident.amount = Number(values?.two_points);
        break;
      case 'three_points':
        incident.amount = Number(values?.three_points);
        break;
      case 'expulsion':
      case 'fault':
        incident.amount = 1;
        break;
      default:
        break;
    }
    form.resetFields();

    try {
      await createMatchIncident(matchId, incident);
      await reloadStats();
      message.success('!Información actualizada!');
      setLoading(false);
    } catch (error) {
      message.error('Algo ocurrió mal. No se pudieron actualizar las estadísticas.');
      setLoading(false);
    }
  };

  const onDeleteIncident = async incidentId => {
    setLoadingDelete(true);
    try {
      await deleteIncident(matchId, incidentId);
      await reloadStats();
      message.success('!Información actualizada!');
      setLoadingDelete(false);
    } catch (error) {
      message.error('Algo ocurrió mal. No se pudieron actualizar las estadísticas.');
      setLoadingDelete(false);
    }
  };

  const getColumns = () => {
    switch (incidentType) {
      case 'card':
        return cardColumns;
      case 'free_throw':
      case 'two_points':
      case 'three_points':
        return registerBkbColumns;
      default:
        return registerGeneralColumns;
    }
  };

  const registerGeneralColumns = [
    {
      title: '# de jugador',
      dataIndex: 'player_number',
    },
    {
      title: 'Equipo',
      dataIndex: 'club_name',
    },
    {
      title: '',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className="text-right">
          <Button
            type="primary"
            danger
            loading={loadingDelete}
            className="mr-2"
            icon={<DeleteOutlined />}
            onClick={() => {
              onDeleteIncident(record.id);
            }}
            size="small"
          />
        </div>
      ),
    },
  ];

  const cardColumns = [
    {
      title: '# de jugador',
      dataIndex: 'player_number',
    },
    {
      title: 'Equipo',
      dataIndex: 'club_name',
    },
    {
      title: 'Tarjeta',
      render: (_, record) => <IncidentCard color={record.card_color} />,
    },
    {
      title: '',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className="text-right">
          <Button
            type="primary"
            danger
            loading={loadingDelete}
            className="mr-2"
            icon={<DeleteOutlined />}
            onClick={() => {
              onDeleteIncident(record.id);
            }}
            size="small"
          />
        </div>
      ),
    },
  ];

  const registerBkbColumns = [
    {
      title: '# de jugador',
      render: (_, record) => record.player.number,
    },
    {
      title: 'Equipo',
      render: (_, record) => record.club.name,
    },
    {
      title: 'Cantidad',
      render: (_, record) => record.amount,
    },
    {
      title: '',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className="text-right">
          <Button
            type="primary"
            danger
            loading={loadingDelete}
            className="mr-2"
            icon={<DeleteOutlined />}
            onClick={() => {
              onDeleteIncident(record.id);
            }}
            size="small"
          />
        </div>
      ),
    },
  ];

  return (
    <Card type="inner" title={title}>
      <Form
        form={form}
        name={`${incidentType}-form`}
        layout="vertical"
        onFinish={values => onSubmit(values)}
      >
        <Form.Item
          label="Número del jugador"
          name="player_number"
          rules={[
            {
              required: true,
              message: 'Ingrese el número del jugador!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Equipo"
          name="club_id"
          rules={[
            {
              required: true,
              message: 'Ingrese el equipo!',
            },
          ]}
        >
          <Select options={teamList} />
        </Form.Item>
        {children}
        <Button loading={loading} htmlType="submit" key="submit" type="primary">
          Guardar
        </Button>
      </Form>
      <Table
        rowKey={obj => Math.floor(Math.random() * Math.floor(Math.random() * Date.now()))}
        style={{ marginTop: '15px' }}
        columns={getColumns()}
        dataSource={data}
      />
    </Card>
  );
};

export default RegisterCard;
